import { render } from "./SoftwareForm.vue?vue&type=template&id=5643a79c&scoped=true"
import script from "./SoftwareForm.vue?vue&type=script&lang=js"
export * from "./SoftwareForm.vue?vue&type=script&lang=js"

import "./SoftwareForm.vue?vue&type=style&index=0&id=5643a79c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5643a79c"]])

export default __exports__